import __vue_normalize__ from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './CheckboxControl.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"b24-checkbox-control",class:_vm.rootClass},[_c('input',{staticClass:"b24-checkbox-control__control",attrs:{"type":"checkbox","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.checked},on:{"change":_vm.handlerChange}}),_vm._v(" "),_c('span',{staticClass:"b24-checkbox-control__inner"},[_c('span',{staticClass:"b24-checkbox-control__indicator"},[_c('check16',{staticClass:"b24-checkbox-control__indicator-icon",attrs:{"width":16,"height":16}})],1),_vm._v(" "),_c('span',{staticClass:"b24-checkbox-control__caption"},[_vm._t("default")],2),_vm._v(" "),(_vm.textErrorDI)?_c('span',{staticClass:"b24-checkbox-control__info"},[_vm._v("\n      "+_vm._s(_vm.textErrorDI)+"\n    ")]):_vm._e()])])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
